import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import AnalyticsDashboard from "../components/AnalyticsDashboard";

import {
  Button,
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
  useTheme,
  Box,
  Stack,
  Container,
  Divider,
} from "@mui/material";
import jsPDF from "jspdf";

const AdminPage = ({ user }) => {
  const navigate = useNavigate();
  const [formDataList, setFormDataList] = useState([]);
  const [loading, setLoading] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const fetchFormData = async () => {
    try {
      const snapshot = await getDocs(collection(db, "formResponses"));
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setFormDataList(data);
    } catch (err) {
      console.error("Error fetching form data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) fetchFormData();
  }, [user]);

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "formResponses", id));
      setFormDataList((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };

  const handleDownload = (data) => {
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text("User Application Details", 10, 10);
    doc.text(`First Name: ${data.firstName || "-"}`, 10, 20);
    doc.text(`Last Name: ${data.lastName || "-"}`, 10, 30);
    doc.text(`Email: ${data.email || "-"}`, 10, 40);
    doc.text(`Address: ${data.address || "-"}`, 10, 50);
    doc.text(`Gender: ${data.gender || "-"}`, 10, 60);
    doc.text(`Salary: ${data.salary || "-"}`, 10, 70);
    doc.text(`Resume: ${data.resume || "-"}`, 10, 80);
    doc.save(`${data.firstName}_${data.lastName}_details.pdf`);
  };

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
        minHeight: "100vh",
        py: 4,
        color: "#fff",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          background: "#ffffff10",
          border: "1px solid #ffffff20",
          borderRadius: "20px",
          backdropFilter: "blur(10px)",
          padding: "2rem",
        }}
      >
        <Typography
          variant="h5"
          fontWeight={600}
          sx={{ color: "#81d4fa", mb: 2, textAlign: "center" }}
        >
          📊 Admin Dashboard
        </Typography>

        <Divider sx={{ mb: 3, borderColor: "#ffffff30" }} />

        {loading ? (
          <Box textAlign="center">
            <CircularProgress sx={{ color: "#81d4fa" }} />
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            sx={{
              backgroundColor: "#1c2b4a",
              color: "#fff",
              borderRadius: "15px",
            }}
          >
            <Table size={isMobile ? "small" : "medium"}>
              <TableHead sx={{ backgroundColor: "#81d4fa" }}>
                <TableRow>
                  {[
                    "First Name",
                    "Last Name",
                    "Email",
                    "Address",
                    "Gender",
                    "Salary",
                    "Resume",
                    "Actions",
                  ].map((head) => (
                    <TableCell
                      key={head}
                      sx={{ fontWeight: "bold", color: "#1e3c72" }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {formDataList.map((data) => (
                  <TableRow key={data.id} hover>
                    <TableCell sx={{ color: "#fff" }}>
                      {data.firstName || "-"}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {data.lastName || "-"}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {data.email || "-"}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {data.address || "-"}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {data.gender || "-"}
                    </TableCell>
                    <TableCell sx={{ color: "#fff" }}>
                      {data.salary || "-"}
                    </TableCell>
                    <TableCell>
                      {data.resume ? (
                        <a
                          href={data.resume}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#81d4fa",
                            textDecoration: "underline",
                          }}
                        >
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => handleDelete(data.id)}
                        >
                          Delete
                        </Button>
                        <Button
                          size="small"
                          variant="contained"
                          sx={{ backgroundColor: "#81d4fa", color: "#1e3c72" }}
                          onClick={() => handleDownload(data)}
                        >
                          Download
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {!loading && <AnalyticsDashboard formDataList={formDataList} />}
      </Container>
    </Box>
  );
};

export default AdminPage;
